import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, FormField, Pagination, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../../components/extras/Favorites';
import SelectPaging from '../../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';

export const SystemSecurityWhiteListPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")
    const [whitelists, setWhitelists] = useState<any[]>([])
    const { navigate } = useRouter();
    const { parameters, menu, data, idAirport } = useGlobalState();
    const [localKeyword, setLocalKeyword] = useState(parameters?.security?.keyword ?? "");

    const [currentPageIndex, setCurrentPageIndex] = useState(1);


    useEffect(() => {
        const timer = setTimeout(() => {
            // Only trigger global update if it actually changed
            if (localKeyword !== parameters?.security?.keyword) {
                setParameters({
                    ...parameters,
                    security: { ...parameters.security, keyword: localKeyword }
                });
            }
        }, 400); // 400ms delay

        return () => clearTimeout(timer);
    }, [localKeyword]);

    useEffect(() => {
        setLocalKeyword(parameters?.security?.keyword || "");
    }, [parameters?.security?.keyword]);

    const filtered = useMemo(() => {
        // 1. If text is shorter than 2 chars, return everything


        if (localKeyword.length < 2) {
            return whitelists;
        }

        const search = localKeyword.toLowerCase();
        // 2. Otherwise, filter by name OR id
        return whitelists.filter(item =>
            item.ip.toLowerCase().includes(search) ||
            item.comments.toString().toLowerCase().includes(search)
        );
    }, [parameters?.security?.keyword, whitelists]);
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);
    useEffect(() => {
        handleGetWhiteLists();
    }, []);

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            handleGetWhiteLists();
        }, 500);
        return () => clearTimeout(timer);
    }, [idAirport]);

    const handleGetWhiteLists = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/security/whitelist/list',
                },
                body: JSON.stringify({
                    date: parameters.date,
                    limit: 100,
                    timeOrder: "ASC"
                }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                setWhitelists(dataWeb.whitelists);
                setCurrentPageIndex(1);
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />} description="Lista de IP autorizadas a accesar los EndPoints">Lista blanca</Header>
                    <Table

                        pagination={

                            <SpaceBetween direction="horizontal" size="xs" alignItems="center">

                                {filtered.length > parameters.pageSize && (
                                    <Pagination
                                        currentPageIndex={currentPageIndex}
                                        pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                    />
                                )}

                                {filtered.length > parameters.pageSize && (

                                    <SelectPaging onSelect={(pageSize) => {
                                        setCurrentPageIndex(1);
                                        setParameters({ ...parameters, pageSize: pageSize });
                                    }} />
                                )}
                            </SpaceBetween>
                        }
                        variant='embedded'
                        stickyHeader
                        filter={
                            <SpaceBetween direction="horizontal" size="xs">
                                <FormField label="Palabra(s) clave(s)">
                                    <TextFilter
                                        filteringText={localKeyword}

                                        onChange={({ detail }) => setLocalKeyword(detail.filteringText)}
                                        filteringPlaceholder="Buscar vuelos..."
                                        filteringAriaLabel="Filtrar vuelos"
                                    />
                                </FormField>
                            </SpaceBetween>
                        }
                        items={paginated ?? []}
                        empty={
                            <Box
                                margin={{ vertical: "xs" }}
                                textAlign="center"
                                color="inherit"
                            >
                                <SpaceBetween size="m">
                                    <b>Sin vuelos en la fecha seleccionada</b>
                                </SpaceBetween>
                            </Box>
                        }
                        cellVerticalAlign='top'
                        contentDensity='compact'
                        wrapLines={false}
                        columnDefinitions={[
                            {

                                id: 'idFlight',
                                header: 'ID',
                                cell: (item) => item.idIP,
                                minWidth: 70,
                            },
                            {

                                id: 'IP',
                                header: 'IP',
                                cell: (item) => item.ip,
                                minWidth: 70,
                            },
                            {

                                id: 'comment',
                                header: 'Comentarios',
                                cell: (item) => item.comments,
                                minWidth: 70,
                            },
                        ]}
                    />
                </SpaceBetween>
            }
        />
    )
};
